import { Employee_Dashboard_Daily_InOut_Dto } from './employee-dashboard-daily-in-out-dto.model';
import { ApiErrorCode } from '../service-proxies';


export class Employee_Dashboard_Daily_InOut_DtoApiResponse implements IEmployee_Dashboard_Daily_InOut_DtoApiResponse {
    isSuccess!: boolean;
    responseData!: Employee_Dashboard_Daily_InOut_Dto;
    errorCode!: ApiErrorCode;
    errorMessage!: string | undefined;
    errorTitle!: string | undefined;

    constructor(data?: IEmployee_Dashboard_Daily_InOut_DtoApiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.responseData = _data["responseData"] ? Employee_Dashboard_Daily_InOut_Dto.fromJS(_data["responseData"]) : <any>undefined;
            this.errorCode = _data["errorCode"];
            this.errorMessage = _data["errorMessage"];
            this.errorTitle = _data["errorTitle"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_Daily_InOut_DtoApiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Daily_InOut_DtoApiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseData"] = this.responseData ? this.responseData.toJSON() : <any>undefined;
        data["errorCode"] = this.errorCode;
        data["errorMessage"] = this.errorMessage;
        data["errorTitle"] = this.errorTitle;
        return data; 
    }
}

export interface IEmployee_Dashboard_Daily_InOut_DtoApiResponse {
    isSuccess: boolean;
    responseData: Employee_Dashboard_Daily_InOut_Dto;
    errorCode: ApiErrorCode;
    errorMessage: string | undefined;
    errorTitle: string | undefined;
}

